import { DialogWrapper } from "../../../CompanyReservation/style/PopupStyles";
import { CancelWrapper } from "../../styled";
interface ReservationCancelPopupProps {
  onClose: () => void;
  handleCancel: () => void;
}
const ReservationCancelPopup = ({
  onClose,
  handleCancel,
}: ReservationCancelPopupProps) => {
  return (
    <DialogWrapper>
      <CancelWrapper>
        <div className="title">해당 토너먼트 예약을 취소하시겠습니까?</div>
        <div className="button-wrapper">
          <div className="button" onClick={() => onClose()}>
            닫기
          </div>
          <div className="button red" onClick={() => handleCancel()}>
            확인
          </div>
        </div>
      </CancelWrapper>
    </DialogWrapper>
  );
};

export default ReservationCancelPopup;
